import { PASSWORD_REGEX, PASSWORD_REQUIREMENTS_MESSAGE } from '@/lib/constants';
import { normalizedEmailField } from '@/validation-schema/email-field';
import * as yup from 'yup';

export const loginSchema = yup.object({
  email: normalizedEmailField(),
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(PASSWORD_REGEX, PASSWORD_REQUIREMENTS_MESSAGE),
  isGoogleSignup: yup.boolean().optional().default(false),
});

export type LoginFormData = yup.InferType<typeof loginSchema>;
